// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"3b8c96fd","110":"b4d3fdb4","140":"76136aaa","422":"d780d36b","453":"c9161952","619":"39d7b853","624":"e6b4d79c","784":"a805402d","841":"7b36b268"}[chunkId] + ".chunk.js";
};